import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/likeAction.svg';

export const IconLikeAction = createIconComponent(Icon);
